module.exports = __webpack_public_path__ + "img/php.eecca103.jpg";